import React from 'react';
import { Shimmer } from '~/ui/components';
import { Content, TopSection } from './TicketDetails.styles';

function TicketDetailsLoading() {
  return (
    <>
      <TopSection>
        <Content>
          <Shimmer width={200} height={32} />
          <Shimmer width={14} height={14} />
        </Content>
        <Content end>
          <Shimmer width={73} height={16} />
          <Shimmer width={80} height={24} br={8} />
        </Content>
      </TopSection>
      <Shimmer width={160} height={25} br={10} mb={20} />
    </>
  );
}

export default TicketDetailsLoading;
